import { KoButton, KoLoader, KoTable, KoText, KoTitle, KoTooltips } from "packages";
import React, { useEffect, useState } from "react";
import styles from "./curd.module.scss";
import KoIcon from "@kwapio/icons";
const OrderDetails = () => {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoading(false);
  }, []);

  const handleRowSelection = (selectedKeys, selectedRows) => {
    console.log("Checked IDs:", selectedKeys);
  };

  const ROWS = [
    {
      orderId: "ORD-1001",
      product: "Noise Cancelling Earbuds",
      price: 149.0,
      status: "Placed",
      total:"$480"
    },
    {
      orderId: "ORD-1002",
      product: "Smartwatch Series 7",
      price: 299.0,
      total:"$380"
    },
    {
      orderId: "ORD-1001",
      product: "Noise Cancelling Earbuds",
      price: 149.0,
      status: "Placed",
      total:"$480"
    },
    {
      orderId: "ORD-1002",
      product: "Smartwatch Series 7",
      price: 299.0,
      total:"$380"
    }
  ];

  const PRO_ITEMS_COLUMNS = [
    { id: "product", label: "PRODUCT", width: 150, widget:"mediaText" },
    {id: "orderId",label: "OrderId",width: 150,fixed: "left"},
    { id: "price", label: "PRICE", width: 150, widget: "number" },
    { id: "total", label: "TOTAL", width: 150, widget: "number" }

  ];

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 10,
    render: (data, row) => (
      <div className={`${styles.table} tableBtn columnsRight`} >
        <KoTooltips title={'Delete'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={20} height={20} name={'DeleteOutlined'} />}
          />
        </KoTooltips>
      </div>
    )
  }];
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.headerInfo}>
            <KoText className={styles.headertext} text="#ORD-1001" level={4} />

            <KoText className={styles.headertext} text="| 3 Product |" level={4} />
            <KoText className={styles.headertext} text="Processing" level={4} />
          </div>
          <div className={styles.headerRight}>
            <KoText text="14 January 2025 10:14" level={4} />
          </div>
          <div className={styles.orderStatus}>
            <KoButton label="Placed" type="primary" />
          </div>
        </div>
      </div>
      <div className={styles.orderContainer}>
        <div className={styles.leftContiner}>
          <div className={styles.orderDetails}>
            <KoTable
              rowKey="id"
              maxHeight={30}
              extraColumnsRight={columnsRight}
              data={{
                visible: true,
                columns: PRO_ITEMS_COLUMNS,
                rows: ROWS
              }}
              onRowSelection={handleRowSelection}
              
            />
          </div>
          <div className={styles.orderSummary}>
            <KoTitle text="Order Summary" level={5} />
            <div className={styles.paymentBox}>
              <KoText text="Payment Method" className={styles.label} />
              <KoText text="Visa*9021" className={styles.value} />
            </div>
            <div className={styles.paymentAmountBox}>
              <KoText text="Subtotal" className={styles.label} />
              <KoText text="$695.00" className={styles.value} />
            </div>
            <div className={styles.paymentAmountBox}>
              <KoText text="Discount" className={styles.label} />
              <KoText text="$50.00" className={styles.value} />
            </div>
            <div className={styles.paymentAmountBox}>
              <KoText text="Shipping" className={styles.label} />
              <KoText text="$25.00" className={styles.value} />
            </div>
            <div className={styles.paymentAmountBox}>
              <KoText text="Insurance" className={styles.label} />
              <KoText text="$00.00" className={styles.value} />
            </div>
            <div className={styles.paymentAmountBox}>
              <KoText text="Tax(5%)" className={styles.label} />
              <KoText text="$34.00" className={styles.value} />
            </div>
            <div className={styles.totalBox}>
              <KoText text="Total" className={styles.label} />
              <KoText text="$704.75" className={styles.value} />
            </div>
          </div>
        </div>
        <div className={styles.rightContiner}>
          <div className={styles.customerDetails}>
            <KoTitle className={styles.Titlelabel} text="Customer Details" level={5} />
            <div className={styles.content}>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="ActiveUseresOutlined" height={16} width={16} />
                  <KoText className={styles.label} text='Name' />
                </div>
                <div className={styles.value}>
                  <KoText className={styles.nameText} text='Jayaprakash' />
                </div>
              </div>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="EmailOutlined" height={16} width={16}  />

                  <KoText className={styles.label} text={'Email Address'} />
                </div>
                <div className={styles.contacts}>
                  <KoText ellipsis={true} className={styles.nameText} text={'jayaprakash@kwapio.com'} />
                </div>
              </div>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="PhoneOutlined" height={16} width={16}  />
                  <KoText className={styles.label} text={'Phone '} />
                </div>
                <div className={styles.contacts}>
                  <KoText className={styles.nameText} text={'9655436081'} />
                </div>
              </div>

            </div>
          </div>
          <div className={styles.shippingDetails}>
            <KoTitle className={styles.Titlelabel} text="Shipping Details" level={5} />
            <div className={styles.content}>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="ShippingTagOutlined" height={16} width={16}  />
                  <KoText className={styles.label} text='Shipping' />
                </div>
                <div className={styles.value}>
                  <KoText className={styles.nameText} text='Kallakurichi ' />
                </div>
              </div>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="ShippingOutlined" height={16} width={16} />

                  <KoText className={styles.label} text='Company' />
                </div>
                <div className={styles.contacts}>
                  <KoText className={styles.nameText} text={'ceo@kwapio.com'} />
                </div>
              </div>

              <div className={styles.viewMode}>
                <div className={styles.label}>
                  <KoIcon name="TelNumberOutlined" height={16} width={16}/>
                  <KoText className={styles.label} text={'Number'} />
                </div>
                <div className={styles.contacts}>
                  <KoText className={styles.nameText} text={'9087654321'} />
                </div>
              </div>

            </div>
          </div>

          <div className={styles.addressDetails}>
            <KoTitle className={styles.Titlelabel} text="Address Details" level={5} />
            <div className={styles.content}>
              <div className={styles.billingAdressBox}>
                <div className={styles.addressBox}>
                  <KoIcon name="LandMarkOutlined" height={16} width={16} />
                  <KoText text="Billing Address" className={styles.label} />
                </div>
                <div className={styles.adressValue} >
                  <KoText className={styles.nameText} text="No 12, 2nd street, Kallakurichi, Tamilnadu, India - 606202" />
                </div>
              </div>

              <div className={styles.shippingAdressBox}>
                <div className={styles.addressBox}>
                  <KoIcon name="LandMarkOutlined" height={16} width={16} />
                  <KoText text="Shipping Address" className={styles.label} />
                </div>
                <div className={styles.adressValue} >
                  <KoText className={styles.nameText} text="No 12, 2nd street, Kallakurichi, Tamilnadu, India - 606202" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default OrderDetails;
